import React from 'react';
import styles from './AddressFooter.module.css';

const ADDRESS_DATA = [
  {
    id: 'main',
    title: 'Headquarters',
    address: ['','MEDA Building, Kakkanad,', 'Ernakulam, Kerala,', 'India - 682037'],
    phone: '+91 484 299 3399',
    email:'info@axldrone.com'
  },
  {
    id: 'palakkad',
    title:'Manufacturing Unit',
    address: ['Kannambra', 'Palakkad, Kerala', 'India - 678686'],
    
  },
  {
    id: 'calicut',
    title:'Global Support Centre',
    address: ['C5 UL Cyber Park, SEZ', 'Calicut, Kerala', 'India - 673016'],
    phone: '+91 495 297 3774'
  },
  {
    id: 'newyork',
    title:'axl Systems USA',
    address: ['1441 Broadway, #5', 'New York,  NY 10018',' United States '],
    phone: '+1 475 356 5668',
    email:'info@axl.systems'
  }
];

const AddressCard = React.memo(({ address, withBorder }) => (
  <div className={`${styles.card} ${withBorder ? styles.withBorder : ''}`}>
    {/* {address.title && <h4 className={styles.title}>{address.title}</h4>} */}
    <div className={styles.addressBlock}>
      {address.title && <p>{address.title}</p>}
      <p><br/></p>
      {address.address.map((line, index) => (
        <p key={index}>{line}</p>
      ))}
      {address.phone && <p>{address.phone}</p>}
      {address.email && <p><a href={`mailto:${address.email}`} style={{ color: 'inherit', textDecoration: 'underline' }}>
      {address.email}
    </a></p>}
    </div>
  </div>
));

AddressCard.displayName = 'AddressCard';

const AddressFooter = () => (
  <section className={styles.container}>
    <div className={styles.layout}>
      {/* Left Section: Main Office */}
      <div className={styles.leftSection}>
        <AddressCard address={ADDRESS_DATA[0]} />
      </div>

      {/* Right Section: Other Locations */}
      <div className={styles.rightSection}>
        <AddressCard address={ADDRESS_DATA[1]} withBorder />
        <AddressCard address={ADDRESS_DATA[2]} withBorder />
        <AddressCard address={ADDRESS_DATA[3]} />
      </div>
    </div>
  </section>
);

export default AddressFooter;
